export default __webpack_public_path__ + "static/media/check-mark-disabled.03756d04.svg";